import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RegisterUserRequest } from "@/store/api/authApiData";

const initialState: RegisterUserRequest = {
  name: "",
  email: "",
  password: "",
  passwordconf: "",
  avatar: null,
  username: "",
  surname: "",
  bio: "",
  registrationCode: "",
};

const signUpSlice = createSlice({
  name: "signUp",
  initialState,
  reducers: {
    setSignUpData: (state, action: PayloadAction<Partial<RegisterUserRequest>>) => {
      return { ...state, ...action.payload };
    },
    resetSignUpData: () => initialState,
  },
});

export const { setSignUpData, resetSignUpData } = signUpSlice.actions;
export default signUpSlice.reducer;
